import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";
import { withUbdAnalyticsStep } from "@aspirasi/react-data-analytics";
import { StoreContext } from "../../../store/context";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { useThemeStyles } from "../../../styles/themes";
import "./MandateFailure.scss";

const MandateFailure = () => {
  const classes = useThemeStyles();
  const history = useHistory();
  const { state, actions } = useContext(StoreContext);

  const reasons = [
    "Your session expired before you could authenticate your debit card",
    "You did not receive the TAC / OTP sent by your selected bank",
    "You do not have enough balance in your bank account for the pre-authorisation",
    "You have entered the wrong card information",
    "You did not enable online transactions with your debit card (please contact your bank to do so)"
  ];

  const handleRetry = () => {
    // Clear URL
    history.replace(history.location.pathname);
    actions.setData({ isRepaymentMethodV2Enable: true });
    actions.setStep("Step8Mandate");
  };

  return (
    state.prerequisites && (
      <>
        <Header />
        <div className="page page-mandate-failure">
          <div className={`${classes.content} ${classes.customScrollbar} content custom-scrollbar`}>

            <div className="body-holder">
              <div className="banner-holder">
                <img className="banner" src="/images/bank-rejected@2x.png" alt="rejected" />
              </div>

              <div className="text-desc" style={{ display: "flex", flexDirection: "column", gap: "16px", marginBottom: "32px" }}>
                <span style={{ fontWeight: 800, fontSize: "18px", lineHeight: "25px" }}>Oops!</span>
                <span>
                  Something went wrong while setting up your auto-debit.
                </span>
                <span style={{ textAlign: "left" }}>
                  This could be due to any of the following reasons:
                </span>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", textAlign: "left" }}>
                  {reasons.map((reason) => (
                    <div key={reason} style={{ display: "flex", gap: "8px" }}>
                      <span style={{ fontSize: "32px" }}>•</span>
                      <span>{reason}</span>
                    </div>
                  ))}
                </div>
                <span>Please try again or use a different payment method if issue persists.</span>
                <span>Need help? Contact us at <a className="contact-link" href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}>creditinfo@myboost.co.</a></span>
              </div>
            </div>

            <div className="action-holder" style={{ position: "sticky", bottom: 0 }}>
              <Button className={`${classes.btnContained} btn-next`} variant="contained" color="primary" onClick={handleRetry}>
                Try Again
              </Button>
            </div>
          </div>
          <Footer />
        </div>
      </>
    )
  );
};

export default withUbdAnalyticsStep(MandateFailure, {
  stepId: "MandateFailure",
  endJourneyOnStepStart: true,
});
